import {Command} from "./Command";
import {LooseGamePlay} from "../model/game-play";
import {Hash} from "../model/hash";

export class SetHashCommand implements Command {
  constructor(
    private gamePlay: LooseGamePlay,
    private hash: Hash
  ) { }

  execute() {
    console.log('COMMAND SetHashCommand', this.hash)
    this.gamePlay.hash = this.hash
  }
}
